import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import TextareaCount from '../../Common/TextareaCount/TextareaCount';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Options extends Component {
    render() { 
        return ( 
            <div className="showtix-section showtix-background__primary-3">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h1>{strings.options}</h1>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="referred">{strings.referredBy}
                                    <span id="tooltip-referredBy" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-referredBy">
                                        {strings.referredByTooltip}
                                    </Tooltip>
                                </label>

                                <div className="showtix-form__input">
                                    <input
                                        id="referred"
                                        className="showtix-input"
                                        type="text"
                                        name="referred_by"
                                        value={this.props.client.referred_by || ''}
                                        onChange={this.props.handleChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label">{strings.acceptDonation}</label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="donation-1"
                                                name="donation"
                                                value="true"
                                                checked={this.props.client.donation === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="donation-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input type="radio" className="showtix-input" id="donation-2"
                                                name="donation"
                                                value="false"
                                                checked={this.props.client.donation === false}
                                                onChange={this.props.handleChange}
                                            /> 
                                            <label className="showtix-label" htmlFor="donation-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="donation-message">{strings.donationMessage}
                                    <span id="tooltip-donationMessage" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-donationMessage">
                                        {strings.donationMessageTooltip}
                                    </Tooltip>
                                </label>

                                <TextareaCount
                                    id="donation-message"
                                    maxLength="250"
                                    name="donation_text"
                                    value={this.props.client.donation_text}
                                    handleChange={this.props.handleChange}
                                />

                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="donation-receipt-message">{strings.donationReceiptMessage}
                                    <span id="tooltip-donationReceiptMessage" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-donationReceiptMessage">
                                        {strings.donationReceiptMessageTooltip}
                                    </Tooltip>
                                </label>

                                <TextareaCount
                                    id="donation-receipt-message"
                                    maxLength="250"
                                    name="donation_email"
                                    value={this.props.client.donation_email}
                                    handleChange={this.props.handleChange}
                                />

                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="captureAddress-1">{strings.captureCustomerAddress}
                                    <span id="tooltip-captureCustomerAddress" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-captureCustomerAddress">
                                        {strings.captureCustomerAddressTooltip}
                                    </Tooltip>
                                </label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="captureAddress-1"
                                                name="collect_cust_info"
                                                value="true"
                                                checked={this.props.client.collect_cust_info === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="captureAddress-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="captureAddress-2"
                                                name="collect_cust_info"
                                                value="false"
                                                checked={this.props.client.collect_cust_info === false}
                                                onChange={this.props.handleChange}
                                            /> <label className="showtix-label" htmlFor="captureAddress-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="willcall-1">{strings.allowWillCall}
                                    <span id="tooltip-allowWillCall" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-allowWillCall">
                                        {strings.allowWillCallTooltip}
                                    </Tooltip>
                                </label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="willcall-1"
                                                name="allow_will_call"
                                                value="true"
                                                checked={this.props.client.allow_will_call === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="willcall-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="willcall-2"
                                                name="allow_will_call"
                                                value="false"
                                                checked={this.props.client.allow_will_call === false}
                                                onChange={this.props.handleChange}
                                            /> <label className="showtix-label" htmlFor="willcall-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="refund-1">{strings.allowRefunds}
                                    <span id="tooltip-allowRefunds" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-allowRefunds">
                                        {strings.allowRefundsTooltip}
                                    </Tooltip>
                                </label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="refund-1"
                                                name="allow_callcenter_refund"
                                                value="true"
                                                checked={this.props.client.allow_callcenter_refund === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="refund-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="refund-2"
                                                name="allow_callcenter_refund"
                                                value="false"
                                                checked={this.props.client.allow_callcenter_refund === false}
                                                onChange={this.props.handleChange}
                                            /> <label className="showtix-label" htmlFor="refund-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="daily-1">
                                    {strings.dailyEmail}
                                    <span id="tooltip-daily" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-daily">
                                        {strings.dailyEmailTooltip}
                                    </Tooltip>
                                </label>
                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="daily-1"
                                                name="daily_email"
                                                value="true"
                                                checked={this.props.client.daily_email === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="daily-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="daily-2"
                                                name="daily_email"
                                                value="false"
                                                checked={this.props.client.daily_email === false}
                                                onChange={this.props.handleChange}
                                            /> <label className="showtix-label" htmlFor="daily-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-12 col-md-6">
                            <div className="showtix-form__group">
                                <label className="showtix-label" htmlFor="exchange-1">{strings.allowExchanges}
                                    <span id="tooltip-allowExchanges" className="showtix-tooltip">!</span>
                                    <Tooltip placement="top" target="tooltip-allowExchanges">
                                        {strings.allowExchangesTooltip}
                                    </Tooltip>
                                </label>

                                <div className="row">
                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="exchange-1"
                                                name="allow_callcenter_exchange"
                                                value="true"
                                                checked={this.props.client.allow_callcenter_exchange === true}
                                                onChange={this.props.handleChange}
                                            />
                                            <label className="showtix-label" htmlFor="exchange-1">{strings.yes}</label>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="showtix-form__radio">
                                            <input
                                                type="radio"
                                                className="showtix-input"
                                                id="exchange-2"
                                                name="allow_callcenter_exchange"
                                                value="false"
                                                checked={this.props.client.allow_callcenter_exchange === false}
                                                onChange={this.props.handleChange}
                                            /> <label className="showtix-label" htmlFor="exchange-2">{strings.no}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    {this.props.client.withdrawal_preference && (
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <div className="showtix-form__group">
                                    <label className="showtix-label">{strings.payouts}</label>

                                    <div className="showtix-form__select">
                                        <select
                                            className="showtix-input"
                                            id="payout_option"
                                            name="payout_option"
                                            value={this.props.client.payout_option || 'check-at-close'}
                                            onChange={this.props.handleChangePayout}
                                        >
                                            <option value="check-at-close">Check at closing</option>
                                            <option value="electronic-at-close">Electronic payment at closing</option>
                                            <option value="recurring-deposit">Reccurring Deposits</option>
                                        </select>
                                    </div>
                                </div>

                                {(this.props.client.payout_option === 'recurring-deposit' && !this.props.stripe_connected) && (
                                    <div className="showtix-form__group">
                                        <a
                                            href={`${this.props.stripe_url}`}
                                            className="showtix-button showtix-background__primary-1"
                                            //target="_blank" rel="noopener"
                                        >
                                            Click to sign-up
                                        </a>
                                    </div>
                                )}

                                {(this.props.client.payout_option === 'recurring-deposit' && this.props.stripe_connected) && (
                                    <div className="showtix-form__group">
                                        <p>You are successfully connected for reoccurring deposits.</p>
                                        <label className="showtix-label">{strings.payouts_frequency}</label>

                                        <div className="showtix-form__select">
                                            <select
                                                className="showtix-input"
                                                id="payout_frequency"
                                                name="payout_frequency"
                                                value={this.props.client.payout_frequency || 'daily'}
                                                onChange={this.props.handleChange}
                                            >
                                                <option value="daily">Daily</option>
                                                <option value="weekly">Weekly</option>
                                                <option value="monthly">Monthly</option>
                                            </select>
                                        </div>
                                    </div>
                                )}
                            </div>

                            { strings.helps &&
                                <div className="col-12 col-md-6">
                                    {strings.helps.map((help, i) =>
                                        <Help help={help} key={i} /> 
                                    )}
                                </div>
                            }
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

Options.propTypes = {
    client: PropTypes.shape({
        options: PropTypes.shape({
            referred_by: PropTypes.string,
            donation : PropTypes.bool,
            donation_text : PropTypes.string,
            donation_email : PropTypes.string,
            collect_cust_info : PropTypes.bool,
            allow_will_call : PropTypes.bool,
            allow_callcenter_refund : PropTypes.bool,
            allow_callcenter_exchange : PropTypes.bool,   
        })
    }),
    handleChange: PropTypes.func,
    updateClient: PropTypes.func,
    isReadyToSubmit : PropTypes.bool
}
 
export default Options;


// WEBPACK FOOTER //
// ./src/components/ClientPreferences/Options/Options.js